import { DateTime } from 'luxon';
import { ClassAttributes, createElement } from 'react';
import ReactTimeAgo from 'react-time-ago';

import { Consumer as StateConsumer } from '../context/state';

type Props = {
  datetime: DateTime;
};

const RelativeTime = ({ datetime }: ClassAttributes<HTMLElement> & Props) => (
  <StateConsumer>
    {(state) =>
      datetime.isValid && <ReactTimeAgo date={datetime.toJSDate()} locale={state.language.split('-')[0]} live={false} />
    }
  </StateConsumer>
);

export default RelativeTime;
